<template>
  <!--
    We use the <section> tag with the ID corresponding to the menu link.
    Bootstrap's 'py-5' class adds vertical spacing (padding).
  -->
  <section id="qui-sommes-nous" class="py-5">
    <div class="container">
      <div class="text-center mb-5">
        <h2 class="display-5 fw-bold">Notre équipe</h2>
        <p class="lead text-muted">Deux professionnelles passionnées à votre service.</p>
      </div>

      <div class="row g-4 justify-content-center">
        <!-- Card for Mrs PEREZ -->
        <div class="col-lg-6">
          <div class="card h-100 shadow-sm border-0 text-center p-4">
            <!--  -->
            <img src="@/assets/photo_sophie_perez.jpg" class="profile-img rounded-circle mx-auto mb-3"
                 alt="Portrait de Sophie PEREZ">
            <div class="card-body">
              <h4 class="card-title">Madame PEREZ Sophie</h4>
              <p class="card-text text-muted">Mariée, deux enfants de 14 ans et 8 ans.</p>
              <p class="card-text text-start">
                J'ai travaillé en tant qu'Auxiliaire de vie scolaire durant 6 ans, j'ai obtenu mon CAP Petite Enfance en
                candidat libre. La maternité a confirmé mon envie de changer de secteur d'activité et de travailler
                auprès des 0-3 ans. Je possède une expérience de 7 ans dans l'accueil, la prise en charge, l'éveil et la
                sécurité des tout-petits. Je suis salariée depuis 2015 dans une micro crèche privé.
              </p>
            </div>
          </div>
        </div>

        <!-- Card for Mrs BAUDRY -->
        <div class="col-lg-6">
          <div class="card h-100 shadow-sm border-0 text-center p-4">
            <!--  -->
            <img src="@/assets/photo_baudry_nathalie.jpeg" class="profile-img rounded-circle mx-auto mb-3"
                 alt="Portrait de Nathalie BAUDRY">
            <div class="card-body">
              <h4 class="card-title">Madame BAUDRY Nathalie</h4>
              <p class="card-text text-muted">Pacsée, deux enfants de 14 et 9 ans.</p>
              <p class="card-text text-start">
                Educatrice spécialisée depuis 2003, je suis diplômée du CAP Petite Enfance. Après 6 années passées au
                service de la Protection de l'Enfance, j'ai souhaité me réorienter vers le secteur de la Petite Enfance
                et revenir au plus près des tout-petits. Je possède une expérience de 7 ans en micro-crèche et d'un an
                en soutien administratif auprès de la référente technique. Je suis salariée depuis 2014 dans une micro
                crèche privé.
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- "Our Vision" Section -->
      <div class="row mt-5">
        <div class="col-lg-10 mx-auto bg-light p-4 p-md-5 rounded text-center">
          <h3 class="fw-bold">Notre Vision Commune</h3>
          <p class="lead mt-3">
            Nous souhaitons mettre à profit notre richesse professionnelle et notre expérience commune en créant
            désormais notre propre structure. Nos forces sont une expérience du terrain, une complémentarité dans nos
            compétences et un esprit d'équipe.
            Nous souhaitons offrir aux enfants un lieu où ils puissent s'épanouir dans un cadre sécurisant, riche en
            possibilités d'éveil tout en respectant leurs droits, leurs rythmes, leurs différences, selon le désir de
            leurs parents et le respect du projet familial dans une relation de confiance indispensable. Nous souhaitons
            créer un lieu chaleureux où chacun pourra se sentir « Comme à la maison ».
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
// No JavaScript logic needed for this component.
</script>

<style scoped>
.profile-img {
  width: 150px;
  height: 150px;
  object-fit: cover; /* Ensures the image fills the circle without distortion */
  border: 4px solid #fff;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}

.card {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.card:hover {
  transform: translateY(-5px); /* Hover levitation effect */
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
}
</style>
